import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const { Options } = require('models')
const { useFetchList } = require('store')

const useRulesMetadata = () => {
	const { i18n } = useGlobal()
	const genericParser = (json) => {
		return {
			...Options.fromSimpleObjectJSON({
				id: `${json.id ?? json.code ?? json.value}`,
				name: i18n.translate(
					json.name ?? json.text ?? json.opinionType
				),
			}),
		}
	}
	const { contents } = useFetchList(
		[
			'/metadata/body_parts',
			'/metadata/insurance_companies',
			'/metadata/process_types',
			'/metadata/provider_entities',
			'/metadata/districts',
			'/metadata/insurance_branches',
			'/metadata/request_types',
			'/metadata/request_states',
			'/metadata/task_eligible_users',

			// EVENT SUBSCRIPTIONS ONLY
			'/metadata/injured_states',
			'/metadata/clinical_states',
			'/metadata/management_type_types',
			'/metadata/appointment_status',
			'/metadata/final_situation_options',
			'/metadata/medical_specialties',
			'/metadata/medics',
			'/metadata/transport_types',
			'/metadata/causal_link_types',
			'/metadata/medical_acts',
			'/metadata/opinion_types',
			'/metadata/opinion_mechanism_types',
			'/metadata/notification_eligible_users',
		],
		[
			({ code, name }) =>
				Options.fromSimpleObjectJSON({
					id: code,
					name: name,
				}),
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
			genericParser,
		]
	)

	const [
		bodyPartsRaw,
		insuranceCompanies,
		processTypes,
		providerEntities,
		districts,
		insuranceBranches,
		requestTypes,
		requestStatus,
		users,
		injuryStates,
		clinicalStates,
		managementTypeTypes,
		appointment_status,
		final_situation_options,
		medical_specialties,
		medics,
		transport_types,
		causal_link_types,
		medical_acts,
		opinion_types,
		opinion_mechanism_types,
		notification_eligible_users,
	] = contents ?? []

	const booleanOptions = ['true', 'false'].map((x) => ({
		value: x,
		text: i18n.translate(x),
	}))

	const entitiesOptions = {
		bodyParts: Array.isArray(bodyPartsRaw) ? bodyPartsRaw : [],
		insuranceCompanies: Array.isArray(insuranceCompanies)
			? insuranceCompanies
			: [],
		insuranceEntity: Array.isArray(insuranceCompanies)
			? insuranceCompanies
			: [],
		processType: Array.isArray(processTypes) ? processTypes : [],
		processTypes: Array.isArray(processTypes) ? processTypes : [],
		providerEntities: Array.isArray(providerEntities)
			? providerEntities
			: [],
		requiringEstablishment: Array.isArray(providerEntities)
			? providerEntities
			: [],
		executionEstablishment: Array.isArray(providerEntities)
			? providerEntities
			: [],
		districts: Array.isArray(districts) ? districts : [],
		branches: Array.isArray(insuranceBranches) ? insuranceBranches : [],
		requisitionTypes: Array.isArray(requestTypes) ? requestTypes : [],
		requisitionType: Array.isArray(requestTypes) ? requestTypes : [],
		requestType: Array.isArray(requestTypes) ? requestTypes : [],
		requisitionStates: Array.isArray(requestStatus) ? requestStatus : [],
		requestState: Array.isArray(requestStatus) ? requestStatus : [],
		requisitionStatus: Array.isArray(requestStatus) ? requestStatus : [],
		// tags: Array.isArray(tags) ? tags.filter(Boolean) : [],
		users: Array.isArray(users)
			? [...users].sort((a, b) => a.text.localeCompare(b.text))
			: [],
		notificationUsers: Array.isArray(notification_eligible_users)
			? [...notification_eligible_users].sort((a, b) =>
					a.text.localeCompare(b.text)
			  )
			: [],
		opinionUser: Array.isArray(users)
			? [...users].sort((a, b) => a.text.localeCompare(b.text))
			: [],
		injuredState: Array.isArray(injuryStates) ? injuryStates : [],
		clinicalState: Array.isArray(clinicalStates) ? clinicalStates : [],
		managerRequest: booleanOptions,
		isPensioner: booleanOptions,
		pensioner: booleanOptions,
		previsionTypes: ['Initial', 'FollowUp', 'Manual'].map((x) => ({
			value: x,
			text: i18n.translate(x),
		})),
		managementType: Array.isArray(managementTypeTypes)
			? managementTypeTypes
			: [],
		clinicalManagementEntity: Array.isArray(managementTypeTypes)
			? managementTypeTypes
			: [],
		appointmentStatus: Array.isArray(appointment_status)
			? appointment_status
			: [],
		appointmentState: Array.isArray(appointment_status)
			? appointment_status
			: [],
		finalSituation: Array.isArray(final_situation_options)
			? final_situation_options
			: [],
		incapacity: Array.isArray(final_situation_options)
			? final_situation_options
			: [],
		medicalSpecialty: Array.isArray(medical_specialties)
			? medical_specialties
			: [],
		expertise: Array.isArray(medical_specialties)
			? medical_specialties
			: [],
		doctor: Array.isArray(medics) ? medics : [],
		transport: Array.isArray(transport_types) ? transport_types : [],
		causalLink: Array.isArray(causal_link_types) ? causal_link_types : [],
		medicalAct: Array.isArray(medical_acts) ? medical_acts : [],
		opinionType: Array.isArray(opinion_types) ? opinion_types : [],
		opinionMechanismType: Array.isArray(opinion_mechanism_types)
			? opinion_mechanism_types
			: [],
		mechanismType: Array.isArray(opinion_mechanism_types)
			? opinion_mechanism_types
			: [],
	}

	return {
		...entitiesOptions,
		...Object.fromEntries(
			Object.entries(entitiesOptions).map(([key, value]) => [
				key.toLowerCase(),
				value,
			])
		),
	}
}

export default useRulesMetadata
